    <div class="modal-content">
      <div class="modal-header header">
        <h5 class="modal-title w-100" [translate]="Localization.CopyChecklist"></h5>
        <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body pt-0 lite-modal m-2">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <img src="assets/images/navbar/buildings.svg" class="mr-1 logo" width="25" height="30">
            <h3>{{Localization.Buildings | translate}}</h3>
          </div>
          <chapps-icon-label [icon]="'fa-info-circle'"
                             [tooltip]="Localization.CopyChecklistTooltip"
                             [tooltipPlacement]="'right'">
          </chapps-icon-label>
        </div>
        <div>
          <p>
            <span style="font-weight: bold;">{{Localization.Note | translate}}
              :</span><span>{{ Localization.CopyChecklistNote | translate}}</span>
          </p>
        </div>
        <div class="d-flex">
          <div class="custom-control custom-checkbox select-all">
            <input type="checkbox" class="custom-control-input" id="selectAll" (change)="selectAll($event)">
            <label class="custom-control-label" for="selectAll" [translate]="Localization.SelectAll"></label>
          </div>
          <div class="search-container d-block w-100 ml-3">
            <input type="text" class="search-input form-control form-control-sm"
                   (keyup)="search($event.target.value)">
            <i class="fa fa-search grey-text"></i>
          </div>
        </div>
        <hr/>
        <div class="scroll-list">
          <form *ngIf="formGroup" [formGroup]="formGroup"
                class="mt-2 realestate"
                [style]="'--number-of-rows: ' + rowsForBuildings">
            <ng-container *ngFor="let realEstate of sitesAndBuildings">

              <ng-template *ngTemplateOutlet="realEstateView; context: {$implicit: realEstate}"></ng-template>

              <ng-template #realEstateView let-realEstate>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                         [id]="realEstate.label+realEstate.id"
                         [formControlName]="realEstate.id"
                          (change)="updateSelection(realEstate)">
                  <label class="custom-control-label"
                         [for]="realEstate.label+realEstate.id">
                    <ng-container *ngIf="isSite(realEstate) then siteLabel; else buildingLabel"></ng-container>

                    <ng-template #siteLabel>
                      <strong>{{ realEstate.label }}</strong>
                      (all buildings)
                    </ng-template>
                    <ng-template #buildingLabel>
                      <strong *ngIf="realEstate.parentStructureId">{{ realEstate.parentStructureLabel }}</strong>
                      {{ realEstate.label}}
                    </ng-template>
                  </label>
                </div>

                <ng-container *ngIf="isSite(realEstate)">
                  <ng-container *ngFor="let building of siteBuildings(realEstate)">
                    <ng-container *ngTemplateOutlet="realEstateView; context: {$implicit: building}"></ng-container>
                  </ng-container>
                </ng-container>
              </ng-template>


            </ng-container>
          </form>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <chapps-secondary-button
          [loading]="isCopyingChecklist"
          [label]="Localization.Copy"
          [small]="true"
          (clicked)="onSubmit()">
        </chapps-secondary-button>
      </div>
    </div>
